import type { LayoutBlock, LayoutConfig } from '@/storefront-runtime/types'

function countActiveBlocks(blocks: LayoutBlock[] | undefined): number {
  if (!Array.isArray(blocks) || blocks.length === 0) return 0
  return blocks.filter((b) => b && typeof b === 'object' && b.visible !== false && b.type).length
}

/**
 * First path segment after `/preview-template/:id/ref/:slug` for template preview entry.
 * Each template lands on **its own** home when configured; otherwise shop — no hardcoded template-id list.
 */
export function templatePreviewEntrySuffix(layout: LayoutConfig | null | undefined): string {
  const pages = layout?.pages
  if (!pages || typeof pages !== 'object') return '/shop'
  if (countActiveBlocks(pages.home) > 0) return ''
  if (countActiveBlocks(pages.shop) > 0) return '/shop'
  return ''
}
